import React from "react";
import { Resizable } from "re-resizable";

interface ResizableContainerProps {
    children: React.ReactNode;
    defaultHeight?: number;
    minHeight?: number;
    maxHeight?: number;
    enableResize?: {
        top?: boolean;
        right?: boolean;
        bottom?: boolean;
        left?: boolean;
        topRight?: boolean;
        bottomRight?: boolean;
        bottomLeft?: boolean;
        topLeft?: boolean;
    };
    style?: React.CSSProperties;
    className?: string;
    onResize?: (height: number, width: number) => void;
}

export const ResizableContainer: React.FC<ResizableContainerProps> = ({
    children,
    defaultHeight = 400,
    minHeight = 10,
    maxHeight = 800,
    enableResize = { bottom: true },
    style,
    className,
    onResize,
}) => {
    return (
        <Resizable
            defaultSize={{
                width: "100%",
                height: defaultHeight,
            }}
            minHeight={minHeight}
            maxHeight={maxHeight}
            enable={enableResize}
            style={style}
            className={className}
        // onResizeStop={(_, __, ref) => {
        //     if (onResize) {
        //         onResize(ref.offsetHeight, ref.offsetWidth);
        //     }
        // }}
        >
            <div className="drag-end d-flex justify-content-center align-items-center">
                <span className="material-symbols-outlined fs-12">drag_handle</span>
            </div>
            {children}
        </Resizable>
    );
};
